export const accordionStyleForSegmentDetail = {
  mb: 2,
  borderRadius: 2,
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    boxShadow: 4,
  },
  "&:before": { display: "none" },
  backgroundColor: "#fff",
  "&.MuiAccordion-root": {
    padding: 0,
  },
  "& .MuiAccordionSummary-root": {
    minHeight: 20,
    padding: "0 8px",
  },
  "& .MuiAccordionSummary-content": {
    margin: "4px 0",
  },
  "& .MuiAccordionDetails-root": {
    padding: "4px 8px",
  },
};

export const accordionTitle = {
  marginTop: 2,
  letterSpacing: 0,
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "19px",
  color: "#0D0D0D",
};

export const accordionSummary = {
  minHeight: "30px", // Set a custom minimum height
  padding: "0 16px", // Adjust the horizontal padding
  "& .MuiAccordionSummary-content": {
    margin: 0, // Remove the default margin
  },
};

export const counterChip = {
  ml: 1,
  fontWeight: 400,
  fontStyle: "normal",
  fontSize: "12px",
  borderRadius: "3px",
  color: "#1F292E",
  backgroundColor: "#EAECEF",
};

export const dateStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 2,

  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "12px",
  color: "#73848C",
};

export const accordionStyle = {
  mb: 2,
  borderRadius: 2,
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    boxShadow: 4,
  },
  "&:before": { display: "none" },
  // backgroundColor: "#fff",
  "&.MuiAccordion-root": {
    padding: 0,
  },
  "& .MuiAccordionSummary-root": {
    minHeight: 20,
    padding: "0 8px",
  },
  "& .MuiAccordionSummary-content": {
    margin: "4px 0",
  },
  "& .MuiAccordionDetails-root": {
    padding: "4px 8px",
  },
};

export const accordionTitleStyle = {
  marginTop: 2,
  letterSpacing: 0,
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "19px",
};

export const accordionSummaryStyle = {
  minHeight: "30px", // Set a custom minimum height
  padding: "0 16px", // Adjust the horizontal padding
  "& .MuiAccordionSummary-content": {
    margin: 0, // Remove the default margin
  },
};

export const counterChipStyle = {
  ml: 1,
  fontWeight: 400,
  fontStyle: "normal",
  fontSize: "12px",
  borderRadius: "3px",
};
